(self.webpackChunkslate_master = self.webpackChunkslate_master || []).push([
	[18],
	{
	  616: () => {
		jQuery.event.special.doubletap = {
		  bindType: "touchend",
		  delegateType: "touchend",
		  handle: function (e) {
			var i = e.handleObj,
			  t = jQuery.data(e.target),
			  o = new Date().getTime(),
			  n = t.lastTouch ? o - t.lastTouch : 0,
			  a = null == a ? 300 : a;
			n < a && n > 30
			  ? ((t.lastTouch = null),
				(e.type = i.origType),
				["clientX", "clientY", "pageX", "pageY"].forEach(function (i) {
				  e[i] = e.originalEvent.changedTouches[0][i];
				}),
				i.handler.apply(this, arguments))
			  : (t.lastTouch = o);
		  },
		};
	  },
	  670: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => u,
		});
		var o = t(609),
		  n = t.n(o),
		  a = t(469),
		  s = t.n(a),
		  r = t(316),
		  l = t.n(r),
		  d = t(860),
		  c = t(646);
		let p = l().View.extend({
		  initialize: function (e) {
			//console.log("init quickshop"), this.quickshop();
		  },
		  events: {},
		  quickshop: function () {
			var e = this,
			  i = function (t, o) {
				t.stopPropagation(), t.preventDefault();
				var a = n()(t.currentTarget);
				if (
				  ((o = o
					? ORW.utilities.updateUrlParam(o, "view", "quickshop")
					: a.data("url")
					? ORW.utilities.updateUrlParam(
						a.data("url"),
						"view",
						"quickshop"
					  )
					: ORW.utilities.updateUrlParam(
						a.attr("href"),
						"view",
						"quickshop"
					  )),
				  //console.log(o),
				  "#?view=quickshop" == o)
				)
				  return !1;
				e.$currentQuickshop && e.$currentQuickshop.destroy(),
				  n().ajax({
					async: !0,
					type: "GET",
					url: o,
					cache: !0,
					error: function (e) {
					  //console.log(e);
					},
					success: function (t) {
					  var o = n()(t).find(".product-quickshop"),
						a = o[0].outerHTML;
					  o.remove(),
						e.$currentModal
						  ? (e.$currentModal.$drawer
							  .find(".product-quickshop")
							  .remove(),
							e.$currentModal.$drawer
							  .find(".drawer-content")
							  .append(a),
							(e.$currentQuickshop = new c.Z({
							  el: n()(
								".product-quickshop .product-detail-container"
							  ),
							})))
						  : d.Z.init({
							  drawerContent: a,
							  drawerModalId: "QuickShopDrawerModal",
							  triggerEvent: "click",
							  triggerElem: ".quick-shop-hidden-trigger",
							  initCallback: function () {
								(e.$currentModal = this),
								  e.$currentModal.openDrawer();
							  },
							  openCallback: function () {
								var i;
								e.$currentQuickshop = new c.Z({
								  el: n()(
									".product-quickshop .product-detail-container"
								  ),
								});
								let t = n()(a)
								  .find(".rc-widget-injection-parent")
								  .data("product-id");
								null === (i = window.ReChargeWidget) ||
								  void 0 === i ||
								  i.createWidget({
									productId: t,
									injectionParent:
									  '.rc-widget-injection-parent[data-product-id="' +
									  t +
									  '"]',
									injectionMethod: "prepend",
									selectors: {
									  price: [".quickshop .product-price"],
									  variant: [
										".quickshop .product-single__variants",
									  ],
									},
								  });
							  },
							  closeCallback: function () {
								e.$currentModal &&
								  (e.$currentModal.destroy(),
								  (e.$currentModal = !1));
							  },
							  events: {
								"ajax-reload-inner": function (e, t) {
								  i(e, t);
								},
							  },
							});
					},
				  });
			  },
			  t = {
				"click .quick-shop-trigger": i,
				"click .quick-shop-trigger-link": i,
			  };
			s().extend(e.events, t), e.delegateEvents();
		  },
		  destroy: function () {
			var e;
			null === (e = window.ReChargeWidget) ||
			  void 0 === e ||
			  e.destroyWidgets(),
			  this.undelegateEvents();
		  },
		});
		const u = {
		  init: function (e) {
			return e.el || (e.el = n()("body")), new p(e);
		  },
		};
	  },
	  211: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => r,
		});
		var o = t(609),
		  n = t.n(o),
		  a = (t(469), t(316));
		let s = t
		  .n(a)()
		  .View.extend({
			initialize: function (e = {}) {
			  let i = this;
			  (i.$target = e.el || void 0),
				(i.maxProducts = 4),
				(i.cookieKey = "recentlyviewed"),
				(i.cookieDays = 30);
			  let t = i.readCookie();
			  i.$target && i.renderProducts(t.products), i.recordCookie(t);
			},
			events: {},
			readCookie: function () {
			  let e = ORW.utilities.getCookie(this.cookieKey);
			  return e
				? JSON.parse(e)
				: {
					products: [],
				  };
			},
			recordCookie: function (e) {
			  let i = this;
			  if (-1 !== window.location.pathname.indexOf("/products/")) {
				let t = window.location.pathname.match(
					/\/products\/([a-z0-9\-]+)/
				  )[1],
				  o = e.products.indexOf(t);
				-1 === o
				  ? (e.products.unshift(t),
					(e.products = e.products.splice(0, i.maxProducts)))
				  : (e.products.splice(o, 1), e.products.unshift(t));
			  }
			  ORW.utilities.setCookie(
				i.cookieKey,
				JSON.stringify(e),
				i.cookieDays
			  );
			},
			renderProducts: function (e) {
			  let i = this;
			  if (!i.$target.is(":empty")) return;
			  let t = e.map((e) => {
				let i = ORW.utilities.updateUrlParam(
				  `/products/${e}`,
				  "view",
				  "thumbnail"
				);
				return new Promise((e, t) => {
				  n()
					.ajax({
					  async: !0,
					  type: "get",
					  url: i,
					})
					.done((i) => e(n()(i)))
					.fail((e) => t(e));
				});
			  });
			  Promise.all(t)
				.then((e) => {
				  var t;
				  i.$target.append(e),
					null === (t = ORW.lazyload) || void 0 === t || t.update();
				})
				.catch((e) => console.log(e));
			},
		  });
		const r = {
		  init: function (e) {
			return new s(e);
		  },
		};
	  },
	  334: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => p,
		});
		var o = t(609),
		  n = t.n(o),
		  a = t(469),
		  s = t.n(a),
		  r = t(316),
		  l = t.n(r),
		  d = t(833);
		let c = l().View.extend({
		  initialize: function (e) {
			var i = this;
			var instance = this;
			(i.optionsMapMix = {}),
			  (i.optionsFlowStr = ["", "", ""]),
			  (i.$content = i.$el),
			  (i.$media = i.$content.find(".product-media")),
			  (i.$optionSelects = i.$content.find(".single-option-selector")),
			  (i.$optionSwatches = i.$content.find(
				".oneswatch:not(.oneswatch-linked) .swatches"
			  )),
			  e.product &&
				(i.buildOptionMaps(e.product),
				(window.optionsMapMix = i.optionsMapMix)),
			  (i.disableImageUpdate =
				void 0 !== e.disableImageUpdate && e.disableImageUpdate);
			let t = n()
			  .makeArray(
				n()(".swatches .swatch").map(function () {
				  return {
					handleized: i.handleize(n()(this).data("name")),
					full: n()(this).data("name")
				  };
				})
			  )
			  .reduce((e, variant) => {
				//console.log("\n=== Checking Image Match ===");
				//console.log("Current variant:", variant.handleized);
				//console.log("Full variant name:", variant.full);
				
				let t = n()(`.image-slide[data-variant-option-value='${variant.handleized}']`);
				//console.log("Direct match found:", t.length);

				//if (t.length == 0) {
				  //console.log("mismatch for variant: " + variant.handleized);
				  //console.log("Attempting alt text match...");
				  //console.log("Looking for alt text containing:", variant.full);
				  
				  // t = n()('.image-slide[data-alt*="'+variant.full+'"]');
                // this should be case insensitive:
					t = n()('.image-slide').filter(function() {
						return new RegExp(variant.full, 'i').test(n()(this).data('alt'));
					});
      //             console.log('---------------------------------');
				  // console.log("Alt text matches found:", t.length);
				  
				  if (t.length) {
					console.log("Success - appending variant-option-value:", variant.handleized);

					// For main slides
					t.each(function() {
					  let currentValues = n()(this).attr('data-variant-option-value') || '';
					  let valueArray = currentValues.split(' ');
					  if (!valueArray.includes(variant.handleized)) {
						  valueArray.push(variant.handleized);
						  n()(this).attr('data-variant-option-value', valueArray.join(' '));
					  }
					  console.log("Updated values:", n()(this).attr('data-variant-option-value'));
					});

					// For thumbnails
					let thumbs = $('.image-thumbnail[data-alt*="'+variant.full+'"]');
					//console.log("Matching thumbnails found:", thumbs.length);
					thumbs.each(function() {
					  let currentValues = n()(this).attr('data-variant-option-value') || '';
					  let valueArray = currentValues.split(' ');
					  if (!valueArray.includes(variant.handleized)) {
						  valueArray.push(variant.handleized);
						  n()(this).attr('data-variant-option-value', valueArray.join(' '));
					  }
					  console.log("Updated thumb values:", n()(this).attr('data-variant-option-value'));
					});
				  }
				//}

				return e || t.length == 0;
			  }, false);

			//console.log("\n=== Final Result ===");
			//console.log("disableImageUpdate set to:", t);

			(i.disableImageUpdate = t),
			  e.preSelect
				? i.$content.find(".single-option-selector").trigger("change")
				: s().each(
					i.$content.find(".single-option-selector"),
					function (e) {
					  n()(e).siblings("label").length
						? n()(e)
							.prepend(
							  '<option value="">' +
								n()(e).siblings("label").text() +
								"</option>"
							)
							.val("")
						: n()(e)
							.prepend('<option value="">Size</option>')
							.val("");
					}
				  ),
			  1 == i.$optionSelects.length && i.updateOptionsInSelector(),
			  n()(window).on("click", function (e) {
				n()(".oneswatch").removeClass("opened");
			  });
		  },
		  events: {
			"click .oneswatch": "swatchDropdown",
			"click .oneswatch:not(.oneswatch-linked) .swatches .swatch":
			  "swatchHandle",
			'click .oneswatch-linked .swatches .swatch:not(".active")':
			  "swatchHandleLink",
			"change .single-option-selector": "dropdownHandle",
		  },
		  swatchDropdown: function (e) {
			e.stopPropagation(), e.preventDefault();
			var i = n()(e.currentTarget);
			i.siblings(".oneswatch").removeClass("opened"),
			  i.toggleClass("opened");
		  },
		  swatchHandleLink: function (e) {
			var i = !1,
			  t = n()(e.currentTarget),
			  o = t.attr("href");
			t.data("ajax") &&
			  ((i = !0), n()("body").trigger("ajax-reload-inner", [o])),
			  i || (window.location.href = o);
		  },
		  swatchHandle: function (e) {
			var i = n()(e.currentTarget),
			  t = i.closest(".swatches"),
			  o = i.closest("form"),
			  a = t.siblings(".swatch-label"),
			  s = t.data("name"),
			  r = t.data("option"),
			  l = i.data("name");
			if (i.hasClass("active")) return !1;
			if (
			  (o.find(".klaviyo-bis-trigger").length &&
				(i.hasClass("disabled")
				  ? o.find(".klaviyo-bis-trigger").show()
				  : o.find(".klaviyo-bis-trigger").hide()),
			  o.attr("id").split("-").length > 1)
			)
			  var d = o.attr("id").split("-")[1],
				c = n()("#productSelect-" + d + "-option-" + r);
			else c = n()("#productSelect-option-" + r);
			c.val(l), c.change(), this.isMobile() && a.text(s + ": " + l);
		  },
		  dropdownHandle: function (e) {
			//console.log("========== Variant Selection Debug ==========");
			//console.log("Dropdown changed:", e.currentTarget);
			//console.log("Selected value:", n()(e.currentTarget).val());
			//console.log("Variant type:", n()(e.currentTarget).data("option"));
			
			this.updateOptionsInSelector(e);
			this.updateSwatches(e);
		  },
		  updateSwatches: function (e) {
			//console.log("updateSwatches");
			var i = this,
			  t = n()(e.currentTarget),
			  o = t.closest("form"),
			  a = t.val(),
			  s = t.data("option").split("option")[1] - 1,
			  r = o.find('.swatches[data-option="' + s + '"]'),
			  l = r.siblings(".swatch-label"),
			  d = r.find(".swatch").filter(function (e) {
				return n()(this).data("select") == a;
			  }),
			  c = r.data("name");
			r.find(".swatch").removeClass("active");
			d && !d.hasClass("active") && d.addClass("active");
			i.isMobile() && l.text(c + ": " + a);
			0 == i.disableImageUpdate && i.updateImage(e, c);
			//console.log("i.disableImageUpdate: " + i.disableImageUpdate);
		  },
		  updateImage: function (e, i) {
			//console.log("\n========== updateImage Debug ==========");
			//console.log("Event:", e);
			//console.log("Variant type (i):", i);
			
			var t = this,
			  o = n()(e.currentTarget),
			  a = t.$content.find(".product-media"),
			  s = a.find("#ProductMediaImages .images-wrapper"),
			  r = a.find("#ProductMediaThumbs .images-wrapper"),
			  l = o.val(),
			  c = t.handleize(l);

			//console.log("Selected value:", l);
			//console.log("Handleized value:", c);
			
			if (i == "size" || i == "style") {
			  //console.log("\nSlider State Check:");
			  //console.log("Is main slider initialized?", s.hasClass('slick-initialized'));
			  //console.log("Is thumb slider initialized?", r.hasClass('slick-initialized'));
			  
			  //console.log("\nBefore unfilter:");
			  //console.log("Main slides:", s.find('.slick-slide').length);
			  //console.log("Main slides with variant value:", s.find(`[data-variant-option-value*="${c}"]`).length);
			  //console.log("All variant values present:", s.find('.image-slide').map(function() {
				//return n()(this).attr('data-variant-option-value');
			  //}).get());
			  
			  s.slick("slickUnfilter");
			  r.slick("slickUnfilter");

			  //console.log("\nAfter unfilter, before new filter:");
			  //console.log("Main slides:", s.find('.slick-slide').length);
			  //console.log("Slides with target variant value:", s.find(`[data-variant-option-value*="${c}"]`).length);
			  //console.log("Looking for variant value:", c);
			  
			  let matchingSlides = s.find(`[data-variant-option-value*="${c}"]`);
			  console.log("Matching slides details:");
			  matchingSlides.each(function(index) {
				console.log(`Slide ${index}:`, {
				  'data-variant-option-value': n()(this).attr('data-variant-option-value'),
				  'data-alt': n()(this).attr('data-alt')
				});
			  });

			  s.slick("slickFilter", `[data-variant-option-value*="${c}"]`);
			  r.slick("slickFilter", `[data-variant-option-value*="${c}"]`);

			  // Reset slide indexes after filtering
			  s.slick('getSlick').$slides.each(function(index, slide) {
				slide.setAttribute('data-slick-index', index);
			  });
			  r.slick('getSlick').$slides.each(function(index, slide) {
				slide.setAttribute('data-slick-index', index);
			  });

			  // Go to first slide
			  s.slick('slickGoTo', 0);
			  r.slick('slickGoTo', 0);
			} else {
			  //console.log("Skipping image update - not a size/style variant");
			}
		  },
		  productJSONCleanup: function (e) {
			var i = e.variants.filter(function (e, i, t) {
			  return -1 === e.title.indexOf("off)");
			});
			return i.length && (e.variants = i), e;
		  },
		  buildOptionMaps: function (e) {
			var i = this;
			e = i.productJSONCleanup(e);
			for (var t = 0; t < e.variants.length; t++) {
			  var o = e.variants[t];
			  o.available &&
				s().each(e.options, function (t, n) {
				  switch (((i.optionsMapMix[n] = i.optionsMapMix[n] || []), n)) {
					case 0:
					  if (1 == e.options.length) {
						var a = o.options[n];
						(i.optionsMapMix[n] = i.optionsMapMix[n] || []),
						  i.optionsMapMix[n].push(o.options[0].toString());
					  }
					  e.options.length > 1 &&
						((a = o.options[n]),
						(i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						i.optionsMapMix[n][a].push(o.options[1]),
						(i.optionsMapMix[n][a] = Shopify.uniq(
						  i.optionsMapMix[n][a]
						))),
						3 === e.options.length &&
						  ((a = o.options[n] + " / " + o.options[1]),
						  (i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						  i.optionsMapMix[n][a].push(o.options[2]),
						  (i.optionsMapMix[n][a] = Shopify.uniq(
							i.optionsMapMix[n][a]
						  )));
					  break;
					case 1:
					  e.options.length > 1 &&
						((a = o.options[n]),
						(i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						i.optionsMapMix[n][a].push(o.options[0]),
						(i.optionsMapMix[n][a] = Shopify.uniq(
						  i.optionsMapMix[n][a]
						))),
						3 === e.options.length &&
						  ((a = o.options[n] + " / " + o.options[0]),
						  (i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						  i.optionsMapMix[n][a].push(o.options[2]),
						  (i.optionsMapMix[n][a] = Shopify.uniq(
							i.optionsMapMix[n][a]
						  )));
					  break;
					case 2:
					  e.options.length > 1 &&
						((a = o.options[n]),
						(i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						i.optionsMapMix[n][a].push(o.options[0]),
						(i.optionsMapMix[n][a] = Shopify.uniq(
						  i.optionsMapMix[n][a]
						))),
						3 === e.options.length &&
						  ((a = o.options[n] + " / " + o.options[0]),
						  (i.optionsMapMix[n][a] = i.optionsMapMix[n][a] || []),
						  i.optionsMapMix[n][a].push(o.options[1]),
						  (i.optionsMapMix[n][a] = Shopify.uniq(
							i.optionsMapMix[n][a]
						  )));
				  }
				});
			}
		  },
		  updateOptionsInSelector: function (e) {
			var i = this,
			  t = function (e, i, o, a) {
				if (!e || !e.length) return a;
				s().each(e, function (e) {
				  if (-1 == n().inArray(e, a)) {
					a.push(e);
					var s = i[o + " / " + e];
					t(s, i, o, a);
				  }
				});
			  };
			if (n().isEmptyObject(i.optionsMapMix)) return !1;
			if (null == e) {
			  //console.log("update without event.......");
			  var o = i.$optionSelects,
				a = (o.find("option"), i.optionsMapMix[0]),
				r = [];
			  o.val("");
			  var l = i.$optionSwatches.find(".swatch").addClass("disabled");
			  return (
				(l = l.filter(function (e, i) {
				  var t = String(n()(i).data("select")),
					o = String(n()(i).data("name"));
				  return -1 != n().inArray(t, a) || -1 != n().inArray(o, a);
				})) &&
				  l.length &&
				  l.removeClass("disabled"),
				!1
			  );
			}
			//console.log("update with event..........");
			var d = n()(e.currentTarget),
			  c = ((r = []), d.val()),
			  p = i.$optionSelects.index(d),
			  u = (a = i.optionsMapMix[p])[c];
			return (
			  r.push(c),
			  t(u, a, c, r),
			  s().each(i.$optionSelects, function (e) {
				var t = n()(e),
				  o = t.val(),
				  a = i.$optionSelects.index(t),
				  s = t.find("option");
				//console.log("o: " + o);
				//console.log("a: " + a);
				//console.log("p: " + p);
				if (a !== p) {
				  r.length ||
					(t.val(""),
					s.attr("disabled", "disabled"),
					(s = s.filter(function (e, i) {
					  return -1 != n().inArray(n()(i).attr("value"), r);
					})) &&
					  s.length &&
					  s.removeAttr("disabled")),
					-1 !== n().inArray(o, r) && t.val(o);
				  var l = i.$optionSwatches
					.filter(function (e, i) {
					  return n()(i).data("option") == a;
					})
					.find(".swatch")
					.addClass("disabled")
					.removeClass("active");
				  (l = l.filter(function (e, i) {
					var t = String(n()(i).data("select"));
					//console.log("t: " + t);
					return -1 != n().inArray(t, r);
				  })) &&
					l.length &&
					l.removeClass("disabled");
				  var d = l.filter('[data-select="' + o + '"]');
				  d && d.length && d.addClass("active");
				}
			  }),
			  !1
			);
		  },
		  handleize: function (e) {
			if (e)
			  return e
				.toLowerCase()
				.replace(/[^a-z0-9]+/g, "-")
				.replace(/-$/, "")
				.replace(/^-/, "");
		  },
		  isMobile: function () {
			return "small" == ORW.responsive;
		  },
		  destroy: function () {
			this.undelegateEvents();
		  },
		});
		const p = {
		  init: function (e) {
			return new c(e);
		  },
		};
	  },
	  495: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => d,
		});
		var o = t(609),
		  n = t.n(o),
		  a = t(469),
		  s = t.n(a),
		  r = t(316);
		let l = t
		  .n(r)()
		  .View.extend({
			initialize: function (e) {
			  this.accordionsAndTabs();
			},
			events: {},
			accordionsAndTabs: function () {
			  var e = this,
				i = {
				  "click .tab-accordion-system .system-title": function (i) {
					!(function (i) {
					  var t = n()(i.currentTarget),
						o = t.parents(".tab-accordion-system"),
						a = t.parent(".system"),
						s = t.data("target"),
						r = o.find('.system-title[data-target="' + s + '"]'),
						l = o.find('.system-content[data-target="' + s + '"]'),
						d = r.parent(".system"),
						c = !!o.hasClass("tab-container");
					  a.siblings().removeClass("active"),
						a
						  .siblings()
						  .find(".system-content")
						  .removeClass("fadeIn animated"),
						c
						  ? (d.addClass("active"),
							e.isMobile() || l.addClass("fadeIn animated"))
						  : d.toggleClass("active");
					})(i);
				  },
				};
			  s().extend(e.events, i), e.delegateEvents();
			},
			isMobile: function () {
			  return "small" == ORW.responsive;
			},
			destroy: function () {
			  this.undelegateEvents();
			},
		  });
		const d = {
		  init: function (e) {
			return e.el || (e.el = n()("body")), new l(e);
		  },
		};
	  },
	  833: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => p,
		});
		var o = t(609),
		  n = t.n(o),
		  a = t(469),
		  s = t.n(a),
		  r = t(316),
		  l = t.n(r),
		  d = t(333);
		let c = l().View.extend({
		  initialize: function (e) {
			var i = this;
			(i.$videoBoxes = i.$el),
			  (i.isResponsive = e.isResponsive || !1),
			  (i.bgVideo = e.bgVideo || !1),
			  (i.autoplay = e.autoplay || !1),
			  i.initVideos();
		  },
		  events: {},
		  initVideos: function () {
			var e = this;
			s().each(e.$videoBoxes, function (i) {
			  var t = n()(i),
				o = t.attr("id"),
				a = t.data("video-type"),
				s = t.data("video-id"),
				r = t.data("video-src");
			  e.bgVideo
				? e.loadHostPlayer(s, r, t, o)
				: "vimeo" == a && e.loadVimeoPlayer(s, r, t, o);
			});
		  },
		  loadHostPlayer: function (e, i, t, o) {
			var a = this,
			  s = "",
			  r = t,
			  l = r.data("ratio") ? r.data("ratio") : 0.6,
			  d = r.find(".video-ctl"),
			  c = function (e) {
				r.width() / r.height() >= e
				  ? r.find("video").css({
					  width: "100%",
					  height: r.width() / e,
					})
				  : r.find("video").css({
					  height: "100%",
					  width: r.height() * e,
					});
			  };
			if (a.autoplay)
			  var p = n()(
				'<video preload="metadata" loop muted autoplay playsinline style="visibility: visible; opacity: 1;"><source src="' +
				  i +
				  '" type="video/mp4"></video>'
			  );
			else
			  p = n()(
				'<video preload="metadata" loop muted playsinline style="visibility: visible; opacity: 1;"><source src="' +
				  i +
				  '" type="video/mp4"></video>'
			  );
			d.text("Play"), t.prepend(p);
			var u = p[0];
  
			function m() {
			  p.isPlaying
				? (u.pause(),
				  d.text("Play"),
				  d.removeClass("playing").addClass("paused"))
				: (u.play(),
				  d.text("Pause"),
				  d.removeClass("paused").addClass("playing"));
			}
			(u.muted = !0),
			  p.on("play", function () {
				(p.isPlaying = !0),
				  d.text("Pause"),
				  d.removeClass("paused").addClass("playing"),
				  (p.isPlaying = !0),
				  t.find("video").css({
					visibility: "visible",
					opacity: "1",
				  });
			  }),
			  p.on("pause", function () {
				(p.isPlaying = !1),
				  d.text("Play"),
				  d.removeClass("playing").addClass("paused"),
				  (p.isPlaying = !1),
				  !a.autoplay &&
					a.bgVideo &&
					t.find("video").css({
					  visibility: "hidden",
					  opacity: "0",
					});
			  }),
			  p.on("click", function () {
				m();
			  }),
			  d.length &&
				(d.text("Pause"),
				d.on("click", function () {
				  m();
				})),
			  p.on("bufferend", function () {
				console.log("video buffered"),
				  a.isResponsive && c(l),
				  console.log("init video");
			  }),
			  a.isResponsive &&
				n()(window).resize(function () {
				  clearTimeout(s),
					(s = setTimeout(function () {
					  c(l);
					}, 400));
				});
		  },
		  loadVimeoPlayer: function (e, i, t, o) {
			var a = this,
			  s = "",
			  r = t,
			  l = r.data("ratio") ? r.data("ratio") : 0.6,
			  c = r.siblings(".video-ctl"),
			  p = function (e) {
				r.width() / r.height() >= e
				  ? r.find("iframe").css({
					  width: "100%",
					  height: r.width() / e,
					})
				  : r.find("iframe").css({
					  height: "100%",
					  width: r.height() * e,
					});
			  };
			if (a.isMobile())
			  var u = new d.Z(o, {
				byline: !1,
				portrait: !1,
				title: !1,
				loop: !1,
				background: !0,
			  });
			else {
			  var m = n()(
				'<iframe frameborder="0" src="' +
				  i +
				  '?title=0&amp;byline=0&amp;portrait=1&amp;autoplay=1&amp;loop=1&amp;controls=0&amp;background=1">'
			  );
			  t.html(m), (u = new d.Z(m));
			}
			c.length &&
			  (a.isMobile()
				? (c.text("Play"),
				  c.removeClass("playing").addClass("paused"),
				  c.on("click", function () {
					u.isPlaying && u.pause(), u.play();
				  }))
				: (c.text("Pause"),
				  c.removeClass("paused").addClass("playing"),
				  c.on("click", function () {
					u.isPlaying
					  ? (u.pause(),
						c.text("Play"),
						c.removeClass("playing").addClass("paused"))
					  : (u.play(),
						c.text("Pause"),
						c.removeClass("paused").addClass("playing"));
				  }))),
			  u.setVolume(0),
			  u.on("play", function () {
				(u.isPlaying = !0),
				  a.isMobile() &&
					(t.find("iframe").css({
					  opacity: "1",
					}),
					c.css({
					  "z-index": "3",
					}),
					c.text("Pause"),
					c.removeClass("paused").addClass("playing")),
				  console.log("played vm video!");
			  }),
			  u.on("pause", function () {
				(u.isPlaying = !1),
				  a.isMobile() &&
					(t.find("iframe").css({
					  opacity: "0",
					}),
					c.text("Play"),
					c.removeClass("playing").addClass("paused")),
				  console.log("pause vm video!");
			  }),
			  u.on("loaded", function () {
				a.isResponsive && p(l), console.log("init vm video");
			  }),
			  a.isResponsive &&
				n()(window).resize(function () {
				  clearTimeout(s),
					(s = setTimeout(function () {
					  p(l);
					}, 400));
				});
		  },
		  destroy: function () {
			this.undelegateEvents();
		  },
		  isMobile: function () {
			return "small" == ORW.responsive;
		  },
		  isDesktop: function () {
			return "large" == ORW.responsive;
		  },
		});
		const p = {
		  init: function (e) {
			return new c(e);
		  },
		};
	  },
	  224: (e, i, t) => {
		"use strict";
		t.r(i);
		var o = t(609),
		  n = t.n(o),
		  a = t(978),
		  s = t(646),
		  r = t(670);
		(0, a.Z)(() => {
		  n()(".product-detail-container").length &&
			new s.Z({
			  el: n()(".product-detail-container"),
			}),
			n()(".product-recommend").length && r.Z.init({});
		});
	  },
	  646: (e, i, t) => {
		"use strict";
		t.d(i, {
		  Z: () => f,
		});
		var o = t(609),
		  n = t.n(o),
		  a = t(469),
		  s = t.n(a),
		  r = t(316),
		  l = t.n(r),
		  d = (t(39), t(154), t(334)),
		  c = t(631);
		t(616);
		let p = l().View.extend({
		  initialize: function (e) {
			var i = this;
			(i.zoomEngaging = !1),
			  (i.zoomInFrame = !0),
			  (i.zoomMobilePan = !1),
			  (i.$productMedia = i.$el),
			  (i.$mainImage = e.mainImage),
			  (i.$thumbImage = e.thumbImage),
			  i.buildDesktopZoom(),
			  i.buildMobileZoom();
		  },
		  events: {
			"click .image-slide:not(.media-video)": "desktopZoomHandle",
			"click #onezoom.opened": "desktopZoomClose",
			"doubletap .image-slide:not(.media-video)": "mobileZoomHandle",
			"doubletap #onezoom-mobile": "mobileZoomHandle",
			"click .onezoom-close": "mobileZoomeOut",
		  },
		  buildDesktopZoom: function () {
			var e = this;
			(e.$zoomContainer = n()('<div id="onezoom"></div>')),
			  e.$zoomContainer.appendTo(e.$productMedia);
		  },
		  buildMobileZoom: function () {
			var e = this;
			(e.zoomMobileEngaging = !1),
			  (e.$zoomMobileContainer = n()(
				'<div id="onezoom-mobile"><div class="panzoom"></div></div>'
			  )),
			  e.$zoomMobileContainer.appendTo(e.$productMedia);
		  },
		  desktopZoomHandle: function (e) {
			var i = this;
			if ((e.preventDefault(), !i.isMobile())) {
			  var t = n()(e.currentTarget),
				o = t.attr("href");
			  if (i.zoomInFrame) {
				function i(e) {
				  var i = a.offset(),
					t =
					  (100 * (e.pageX - i.left)) / a.width() +
					  "% " +
					  (100 * (e.pageY - i.top)) / a.height() +
					  "%";
				  a.css("background-position", t);
				}
				if (t.find(".onezoom-frame").length)
				  (a = t.find(".onezoom-frame")).off("mousemove"), a.remove();
				else {
				  var a = n()(
					'<div class="onezoom-frame loading-image">'
				  ).appendTo(t);
				  n()("<img/>")
					.attr("src", o)
					.on("load", function () {
					  n()(this).remove(),
						i(e),
						a.removeClass("loading-image"),
						a.css("background-image", "url(" + o + ")"),
						a.on("mousemove", (e) => {
						  i(e);
						});
					});
				}
			  } else {
				var s = n()('<img class="zoomed-image" src="' + o + '" />');
				i.$zoomContainer.html(s),
				  s.on("load", function () {
					i.$zoomContainer.removeClass("loading-image");
				  }),
				  i.zoomEngaging ||
					(i.zoomStatus("engage"),
					i.$zoomContainer.addClass("opened loading-image"));
			  }
			}
		  },
		  desktopZoomClose: function (e) {
			var i = this;
			i.$zoomContainer.on("transitionend", function () {
			  i.$zoomContainer.off("transitionend"),
				i.$zoomContainer.html(""),
				i.zoomStatus("disengage");
			}),
			  i.$zoomContainer.removeClass("opened");
		  },
		  mobileZoomHandle: function (e) {
			var i = this;
			i.isMobile() &&
			  (i.$zoomMobileEngaging ? i.mobileZoomeOut() : i.mobileZoomeIn(e));
		  },
		  mobileZoomeIn: function (e) {
			let i = this,
			  t = e,
			  o = n()(e.currentTarget),
			  a = o.find("img"),
			  s = n()(`<img src="${o.attr("href")}" />`);
			(i.$zoomMobileCloseIcon = n()('<div class="onezoom-close"></div>')),
			  i.$zoomMobileContainer
				.addClass("opened loading-image")
				.find(".panzoom")
				.append(s),
			  i.$zoomMobileContainer.prepend(i.$zoomMobileCloseIcon),
			  e.changedTouches && (t = e.changedTouches[0]),
			  s.on("load", function () {
				var e, o, n, r;
				i.$zoomMobileContainer.removeClass("loading-image");
				const l =
					(null == s ? void 0 : s.width()) /
					(null == a ? void 0 : a.width()),
				  d = {
					x:
					  ((null === (e = i.$mainImage) || void 0 === e
						? void 0
						: e.offset().left) -
						(null === (o = t) || void 0 === o ? void 0 : o.pageX)) *
						l +
					  (null == a ? void 0 : a.width()) / 2,
					y:
					  ((null === (n = i.$mainImage) || void 0 === n
						? void 0
						: n.offset().top) -
						(null === (r = t) || void 0 === r ? void 0 : r.pageY)) *
						l +
					  (null == a ? void 0 : a.height()) / 2,
				  },
				  p = i.$zoomMobileContainer.find(".panzoom").get(0);
				i.zoomMobilePan = (0, c.Z)(p, {
				  contain: "outside",
				  startScale: 1,
				  startX: d.x,
				  startY: d.y,
				});
			  }),
			  (this.$zoomMobileEngaging = !0);
		  },
		  mobileZoomeOut: function (e) {
			var i = this;
			if (!this.$zoomMobileContainer) return !1;
			i.zoomMobilePan && i.zoomMobilePan.destroy(),
			  i.$zoomMobileContainer.on("transitionend", function () {
				i.$zoomMobileContainer.off("transitionend"),
				  i.$zoomMobileContainer.html('<div class="panzoom"></div>'),
				  (i.$zoomMobileEngaging = !1);
			  }),
			  this.$zoomMobileContainer.removeClass("opened");
		  },
		  zoomStatus: function (e) {
			"engage" == e
			  ? ((this.zoomEngaging = !0), n()("html").addClass("zooming"))
			  : "disengage" == e &&
				((this.zoomEngaging = !1), n()("html").removeClass("zooming"));
		  },
		  isMobile: function () {
			return "small" == ORW.responsive;
		  },
		  destroy: function () {
			this.undelegateEvents();
		  },
		});
		const u = function (e) {
		  return new p(e);
		};
		t(860);
		var m = t(495),
		  g = t(833),
		  h = t(211);
		const f = l().View.extend({
		  initialize: function (e) {
			console.log("init PDP");
			var i = this,
			  t = "[data-product-json]";
			(i.$content = i.$el),
			  (i.$body = n()("body")),
			  (i.$media = i.$content.find(".product-media")),
			  (i.$mainImage = i.$media.find("#ProductMediaImages")),
			  (i.$thumbImage = i.$media.find("#ProductMediaThumbs")),
			  (i.$mediaSlider = i.$mainImage.find(".images-wrapper")),
			  (i.$thumbSlider = i.$thumbImage.find(".images-wrapper")),
			  (i.$productCore = i.$content.find(".product-core")),
			  (i.$socialIcons = i.$productCore.find(".one-social")),
			  (i.productJSON =
				!!i.$content.find(t).length &&
				JSON.parse(i.$content.find(t).html())),
			  (i.isGiftCard = i.$content.hasClass("gift-card")),
			  (i.$productExtra = i.$content.find(".product-extra")),
			  (i.$yotpoReviews = i.$content.find("#yotpo-product-reviews")),
			  (i.enableMiniCore = !1),
			  (i.isScrollingLayout = "scrolling" == i.$content.data("layout")),
			  (i.isScrollingGrid = i.$content.hasClass("scrolling-grid")),
			  (i.isSliderLayout = "slider" == i.$content.data("layout")),
			  (i.isQuickshopLayout = "quickshop" == i.$content.data("layout")),
			  i.isGiftCard || i.productMedia(),
			  i.productCore(),
			  i.isQuickshopLayout || i.social(),
			  i.isGiftCard ||
				i.isQuickshopLayout ||
				(i.zoom(), i.video(), i.accordionsAndTabs(), h.Z.init()),
			  i.initRecentlyViewed(),
			  i.yotpoReviewsWidget();
		  },
		  events: {
			"click .add-to-cart-form .quantity-wrapper span"(e) {
			  const i = n()(e.currentTarget),
				t = i.siblings("input"),
				o = +(t.val() || 1);
			  (document.querySelector(".product-quantity-max") &&
				i.is("[data-inc]") &&
				ORW.qty_limit &&
				o >= ORW.qty_limit) ||
				(i.is("[data-dec]") && o <= +t.attr("min")) ||
				t.val(i.is("[data-dec]") ? o - 1 : o + 1);
			},
			"click .product-media-images__last"(e) {
			  n()(".product-media-images .images-wrapper").slick("slickPrev");
			},
			"click .product-media-images__next"(e) {
			  n()(".product-media-images .images-wrapper").slick("slickNext");
			},
		  },
		  swatches: function () {
			var e = this,
			  i = "productSelect";
			e.isQuickshopLayout &&
			  (i = e.$productCore.find(".product-single__variants").attr("id")),
			  new Shopify.OptionSelectors(i, {
				product: e.productJSON,
				onVariantSelected: e.isGiftCard
				  ? function (e, i) {}
				  : ShopifyAPI.selectCallback,
				enableHistoryState: !e.isQuickshopLayout,
			  }),
			  e.isGiftCard ||
				d.Z.init({
				  el: e.$content,
				  preSelect: !0,
				  product: e.productJSON,
				  disableImageUpdate: !1,
				});
		  },
		  ajaxCart: function () {
			n()(".add-to-cart-form").off("submit"),
			  ajaxCart.init({
				formSelector: ".add-to-cart-form",
				addToCartSelector: ".add-to-cart-btn",
				cartContainer: ".minicart-container",
				cartCountSelector: ".minicart-count",
				cartCostSelector: ".minicart-cost",
				moneyFormat: theme.moneyFormat,
			  });
		  },
		  productMedia: function () {
			var e = this;
			e.$mediaSlider.slick({
			  dots: !0,
			  infinite: !0,
			  speed: 600,
			  slidesToShow: 1,
			  asNavFor: e.$thumbSlider,
			  arrows: e.isQuickshopLayout,
			  rows: 0,
			}),
			  e.$thumbSlider.slick({
				asNavFor: e.$mediaSlider,
				vertical: !0,
				verticalSwiping: !0,
				infinite: false,
				slidesToShow: 6,
				focusOnSelect: !0,
				arrows: !1,
				adaptiveHeight: !0,
				rows: 0,
			  });
		  },
		  productCore: function () {
			var e = this;
			e.swatches(),
			  e.ajaxCart(),
			  e.isQuickshopLayout ||
				(e.enableMiniCore && e.productCoreMini(),
				e.isScrollingLayout &&
				  !e.isScrollingGrid &&
				  e.productCoreScrollFixing());
		  },
		  productCoreScrollFixing: function () {
			var e = this;
			(e.$scrollFixingCore = e.$productCore.find(".product-core-inner")),
			  ORW.utilities.mediaCheck(
				function () {
				  e.$scrollFixingCore.scrollToFixed({
					zIndex: 2,
					removeOffsets: !0,
					dontSetWidth: !0,
					marginTop: function () {
					  return n()("header.site-header").outerHeight() + 50;
					},
					limit: function () {
					  return (
						n()(".scrolling-fix-stopper").offset().top -
						n()(this).height()
					  );
					},
				  });
				},
				function () {
				  e.$scrollFixingCore.trigger("detach.ScrollToFixed");
				}
			  );
		  },
		  productCoreMini: function () {
			var e = this,
			  i = function (e) {
				console.log("init minicore"),
				  e.scrollToFixed({
					zIndex: 2,
					removeOffsets: !0,
					dontSetWidth: !0,
					triggerAtBottom: !0,
					marginTop: function () {
					  return -1 * n()(this).height();
					},
					fixed: function () {
					  n()(this).addClass("fixed-core fadeInUp animated");
					},
					unfixed: function () {
					  n()(this).removeClass("fixed-core fadeInUp animated");
					},
				  });
			  };
			(e.$miniCore = e.$productCore.find(".block-core")),
			  ORW.utilities.mediaCheck(
				function () {
				  e.$miniCore.trigger("detach.ScrollToFixed"),
					(e.isScrollingLayout && !e.isScrollingGrid) || i(e.$miniCore);
				},
				function () {
				  e.$miniCore.trigger("detach.ScrollToFixed"), i(e.$miniCore);
				}
			  );
		  },
		  social: function () {
			var e = this,
			  i = {
				"click .share-title": function (i) {
				  e.$socialIcons.toggleClass("active");
				},
			  };
			s().extend(e.events, i), e.delegateEvents();
		  },
		  zoom: function () {
			var e = this;
			u({
			  el: e.$media,
			  mainImage: e.$mainImage,
			  thumbImage: e.$thumbImage,
			});
		  },
		  video: function () {
			var e = this.$content.find(".video-wrapper");
			g.Z.init({
			  el: e,
			  isResponsive: !1,
			  bgVideo: !0,
			  autoplay: !1,
			});
		  },
		  accordionsAndTabs: function () {
			m.Z.init({
			  el: this.$productCore,
			}),
			  m.Z.init({
				el: n()(".description-module"),
			  }),
			  n()(".description-module .system-title").on("click", function () {
				n()(".description-module .module-background").removeClass(
				  "active"
				),
				  n()(
					".description-module .module-background-mobile"
				  ).removeClass("active"),
				  n()(n()(this).data("bg-elem")).each(function (e) {
					n()(this).addClass("active");
				  });
			  });
		  },
		  initRecentlyViewed: function () {
			h.Z.init({
			  el: n()(".recently-viewed .items"),
			});
		  },
		  yotpoReviewsWidget: function () {
			var e = this;
			new Promise((i, t) => {
			  var o = setInterval(() => {
				"string" ==
				  typeof e.$yotpoReviews
					.find(".yotpo-reviews.yotpo-active .total-reviews-search")
					.attr("total-reviews-search") &&
				  (clearInterval(o),
				  (e.$numOfReviews = parseInt(
					e.$yotpoReviews
					  .find(".yotpo-reviews.yotpo-active .total-reviews-search")
					  .attr("total-reviews-search")
				  )),
				  (e.$yotpoMainWidget = e.$yotpoReviews.find(
					".main-widget.yotpo-display-wrapper.yotpo-label-border"
				  )),
				  i());
			  }, 100);
			}).then(() => {
			  e.adjustYotpoReviewsWidget();
			});
		  },
		  adjustYotpoReviewsWidget: function () {
			if (window.innerWidth > ORW.responsiveSizes.medium) {
			  const i = this.$numOfReviews;
			  var e = 0;
			  i > 0 && i < 6 ? (e = 325 * i) : i > 5 && (e = 1700),
				this.$yotpoMainWidget.css("min-height", `${e}px`);
			}
		  },
		  destroy: function () {
			this.undelegateEvents();
		  },
		  responsive: function () {
			ORW.utilities.mediaCheck(
			  function () {},
			  function () {}
			);
		  },
		  isMobile: function () {
			return "small" == ORW.responsive;
		  },
		});
	  },
	},
  ]);
  
  // jQuery('#notify-me').click(function() {
  //
  // jQuery('#notify-me-wrapper').fadeIn();
  //
  // return false;
  // } );
  
  let rootIstance = this;
  
  function scrollTo(destY) {
	jQuery("html, body").stop("true");
	window.stop(true, false);
	window.scroll({
	  behavior: "smooth",
	  left: 0,
	  top: destY,
	});
  }
  
  function getHeaderHeight() {
	let windowWidth = jQuery(window).width();
	let headerHeight = windowWidth > 1024 ? 160 : 117;
	return headerHeight;
  }
  
  function assignPagerClicks() {
	console.log("assignPagerClicks");
	jQuery(".yotpo-horizontal-pagination a").unbind();
	jQuery(".yotpo-horizontal-pagination a").on("click", function () {
	  setTimeout(function () {
		console.log("pager a click");
		let destElement = jQuery(".yotpo-filters-container");
		let headerHeight = getHeaderHeight();
		if (destElement.length) {
		  scrollTo(destElement.offset().top - headerHeight);
		}
		rootIstance.assignPagerClicks();
	  }, 500);
	});
  }
  
  setTimeout(function () {
	let topStars = jQuery(".yotpo-sr-bottom-line-summary");
	console.log("topStars.length: " + topStars.length);
  
	topStars.on("click", function (e) {
	  e.preventDefault();
	  console.log("stars click");
	  jQuery("html, body").stop("true");
	  let id = ".review-container";
	  let destElement = jQuery(id);
	  let headerHeight = getHeaderHeight();
	  if (destElement.length) {
		scrollTo(destElement.offset().top - headerHeight);
	  }
	});
	//console.log("window.location.hash: " + window.location.hash);
	  if (window.location.hash == '#reviews') {
		  console.log("trigger reviews click");
		  topStars.trigger('click');
	  }
	assignPagerClicks();
  }, 2000);
  
  let disableSku;
  let disableNotify;
  
  function checkSubscription() {
	  if (!disableSku) return;
	  const urlParams = new URLSearchParams(window.location.search);
	  const variant = urlParams.get('variant');
	  console.log("variant: " + variant);
	  
	  if (variant == disableSku) {
		  console.log("variant match.");
		  $('.rc_widget__option__selector input[value="onetime"]').trigger('click');
		  $('.rc-widget-injection-parent,.rc-container-wrapper').hide();
	  } else {
		  $('.rc-widget-injection-parent,.rc-container-wrapper').show();
	  }
  }
  
  $(document).ready(function () {
  
	disableSku = $('.product-attribute-container').data('disable-subscription-sku');
	disableNotify = $('.product-attribute-container').data('disable-notify');
	console.log("disableNotify: " + disableNotify);
  
	let notifyBtn = $('.klaviyo-bis-trigger');
	  console.log("notifyBtn.length: " + notifyBtn.length);
  
	  setTimeout(function() {
		  if (disableNotify) $('.klaviyo-bis-trigger').hide();
	  }, 500);
	  
	  setTimeout(function() {
		  if (disableNotify) $('.klaviyo-bis-trigger').hide();
	  }, 1000);
	
	setTimeout(function () {
	  let itemsCount = $(".recently-viewed .items .item").length;
	  console.log("itemsCount delay: " + itemsCount);
	  if (itemsCount < 2) {
		console.log("hide recently viewed");
		$(".recently-viewed").hide();
	  }
	}, 1000);
  
	$(".product-attribute-container .swatches .swatch").on("click", function () {
	  setTimeout(function () {
		let notifyBtn = $(".klaviyo-bis-trigger");
		let vis = notifyBtn.css("display");
		//console.log("vis: " + vis);
		let addToCartText = $("#AddToCart .add-to-cart-text").text();
		//console.log("addToCartText: " + addToCartText);
		if (addToCartText == "Sold Out" && vis == "none" && !disableNotify) {
		  notifyBtn.css("display", "inline-block");
		}
		checkSubscription();
	  }, 200);
	});
  
	$(".video-cta").on("click", function () {
	  let parentEl = $(this);
	  let video = parentEl.find("video");
	  if (parentEl.hasClass("playing")) {
		video[0].pause();
		parentEl.removeClass("playing");
	  } else {
		video[0].play();
		parentEl.addClass("playing");
	  }
	});
  
	setTimeout(function() {
		  checkSubscription();
	  }, 1000);
  });
  